export default "__VITE_ASSET__BD4QGXvy__"